/*
 * File: DeliveryAddressCountrySelector.tsx
 * Project: papa-bear
 * -----
 * Last Modified: 18 Jan 2022 12:47:18 pm
 * -----
 * Copyright (c) 2022 Elegant Software Solutions All rights reserved.
 */

import { Form, Select, SelectProps } from 'antd';
import { FormLabel } from 'components/UI/FormItems/FormLabel';
import { Country } from 'country-state-city';
import { useFormikContext } from 'formik';
import { Address } from 'redux/services/chuckieSue/models/addresses';

interface Props extends SelectProps {
  currentValue: string;
}

export const CountrySelectInput = ({ currentValue, ...rest }: Props): JSX.Element => {
  const countries = Country.getAllCountries();
  const { setValues, values } = useFormikContext<Address>();

  const countryNames = countries.map((country) => ({ label: country.name, value: country.name }));
  const currentCountryName = countries.find((country) => country.isoCode === values.country.alpha2Code);

  const onChange = (value: string) => {
    setValues((prev) => ({
      ...prev,
      country: {
        ...prev.country,
        alpha2Code: countries.find((country) => country.name === value)?.isoCode ?? '',
        shortName: value,
        fullName: value
      }
    }));
  };

  /* ****************** Render ****************** */
  return (
    <Form.Item style={{ margin: 0 }} label={<FormLabel label="Country" />}>
      <Select
        style={{ margin: 0 }}
        defaultActiveFirstOption={true}
        placeholder="Select a Country"
        defaultOpen={false}
        value={currentCountryName ? currentCountryName.name : undefined}
        onSelect={onChange}
        showSearch
        options={countryNames ? countryNames : undefined}
        {...rest}
      />
    </Form.Item>
  );
};
